import settings from '@/data/constants';
import { QueryKey } from '@/data/query';
import type { apiV1Contract } from '@montugroup/pms-api-contracts';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export type DischargeReason = Zod.infer<(typeof apiV1Contract.patient.getDischargeReasons.responses)['200']>[0];
export type DischargeReasons = DischargeReason[];

export const useGetDischargeReasons = () => {
  const getDischargeQuery = useQuery<DischargeReasons>({
    queryKey: [QueryKey.GetDischargeReasons],
    queryFn: async () => {
      const response = await axios.get(`${settings.url}/patient/dischargeReasons`);
      return response.data;
    }
  });

  return { ...getDischargeQuery };
};
